import { useCallback, useState, type RefObject } from 'react'
import { type ProductReviewStats } from '@/features/shop/services/Shelves/types'

interface UseProductDetailRatingsAndReviewsProps {
  reviewStats?: ProductReviewStats
  dockedAtcButtonRef: RefObject<HTMLDivElement | null>
}
export const useProductDetailRatingsAndReviews = ({
  reviewStats,
  dockedAtcButtonRef,
}: UseProductDetailRatingsAndReviewsProps) => {
  const [isAtcVisible, setIsAtcVisible] = useState(false)

  const showRatingsAndReviews = !!reviewStats?.rating_distribution
  const isUnderline = (reviewStats?.total_ratings ?? 0) > 0

  const getAtcButtonRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (node && showRatingsAndReviews) {
        const handleAtcScroll = () => {
          setIsAtcVisible(node.getBoundingClientRect().bottom < 0)
        }
        handleAtcScroll()

        window.addEventListener('scroll', handleAtcScroll)
        return () => {
          window.removeEventListener('scroll', handleAtcScroll)
        }
      }
    },
    [showRatingsAndReviews],
  )

  const scrollToRatingsAndReview = () => {
    const ratingAndReviewsSection = document.getElementById('ratingsAndReviewsSection')

    if (ratingAndReviewsSection) {
      const elementPosition = ratingAndReviewsSection.getBoundingClientRect().top + window.scrollY

      const offsetHeight = dockedAtcButtonRef.current ? dockedAtcButtonRef.current.offsetHeight : 0

      window.scrollTo({
        top: elementPosition - offsetHeight * 2,
        behavior: 'smooth',
      })
    }
  }

  return {
    showRatingsAndReviews,
    isUnderline,
    isAtcVisible,
    getAtcButtonRef,
    scrollToRatingsAndReview,
  }
}
